/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import { createReduxStore, fetchCurrentUser } from "./common/store";
import { MODULES } from "./common/constants";

const StaffActivity = (props) => {
  let {
    organizationId,
    locationId,
    objectId,
    regionId,
    params: { calendarStartDate, calendarEndDate, theBeginningOfTime, modules, currencySymbol },
    notifications
  } = props;

  const initialData = {
    organizationId,
    locationId,
    objectId,
    regionId,
    calendarStartDate,
    calendarEndDate,
    theBeginningOfTime,
    currencySymbol
  };

  const store = createReduxStore(
    "staffActivity",
    modules.map(({ moduleName }) => moduleName)
  );

  store.dispatch(fetchCurrentUser(initialData));

  let modulesToRender = modules.map(({ moduleName }) => ({
    ...MODULES[moduleName]
  }));

  return (
    <Provider store={store}>
      {modulesToRender.map(({ Component, moduleName }) => {
        return Component && <Component key={moduleName} notifications={notifications} />;
      })}
    </Provider>
  );
};

StaffActivity.propTypes = { props: PropTypes.object };

export default StaffActivity;
